// extracted by mini-css-extract-plugin
export default {"default":"flying-btn_default__0KNsJ","default_hide":"flying-btn_default_hide__+FxpG","default_none":"flying-btn_default_none__DYd9B"};